import { render } from "./load_button.vue?vue&type=template&id=0e854e51"
import script from "./load_button.vue?vue&type=script&lang=js"
export * from "./load_button.vue?vue&type=script&lang=js"

import "./load_button.vue?vue&type=style&index=0&id=0e854e51&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__